import React, {useEffect, useState} from 'react';
import {Form, Row, Col, Input, Button, Upload} from 'antd';
import {DownOutlined, UpOutlined, SearchOutlined, PlusOutlined, ReloadOutlined, DownloadOutlined, UploadOutlined } from '@ant-design/icons';
import {observer} from 'mobx-react';

import styles from './index.module.less';
import {useTranslation} from "react-i18next";


export class SearchFormItem extends React.Component {
  constructor(props) {
    super(props)
  }

  render() {
    return (
      <Col span={this.props.span} offset={this.props.offset}>
        <Form.Item label={this.props.title} name={this.props.name} className={styles.searchFormItem}>
          {this.props.children}
        </Form.Item>
      </Col>
    )
  }
}

export default observer(function (props) {
  const {t, i18n} = useTranslation()
  const [expand, setExpand] = useState(false)
  const [form] = Form.useForm()

  useEffect(()=>{
    setExpand(props.expand);
  },[props.expand]);

  const onFinish = (values) => {
    props.onFinish(values)
  }

  const onReset = () => {
    form.resetFields();
    if (props.onReset) {
      props.onReset();
    }else{
      props.onFinish({});
    }
  }

  return (
    <div className={styles.searchFormBox}>
      <Form
            form={form}
            name="advanced_search"
            onFinish={onFinish}>
          <Row 
          style={{...props.style,height: !expand ? '42px' : props.height ? props.height : 'auto'}}
          className={styles.searchForm}>
            {props.children}
          </Row>
        <div className={styles.btns}>
          <div className='btn-container'>
          <Button style={{marginRight: '8px',display:props.isImport?'inline-block':'none'}} onClick={()=>{props.onImport()}} type="primary">{t('导入')}</Button>
          <Button style={{marginRight: '8px',display:props.isExport?'inline-block':'none'}} onClick={()=>{props.onExport()}} type="primary">{props.isExportDetail?t('导出行'):t('导出')}</Button>
              {/* <Upload
                  action=""
                  style={{marginRight: '8px',display:props.isImport?'inline-block':'none'}}
                  customRequest={props.onUploadFile}
                  showUploadList={false}
                >
                  <Button 
                  className='export-btn'
                  type="primary" 
                  style={{marginRight: '8px',display:props.isImport?'inline-block':'none'}}
                  >导入</Button>
                </Upload> */}
              <Button style={{marginRight: '8px',display:props.isExportDetail?'inline-block':'none'}} onClick={()=>{props.onExportDetail()}} type="primary">{t('导出明细')}</Button>
              <Button loading={props.exportCertLoading} style={{marginRight: '8px',display:props.isExportDetail?'inline-block':'none'}} onClick={()=>{props.onExportCert()}} type="primary">{t('导出证书')}</Button>
              <Button style={{marginRight: '8px',display:props.isCreate?'inline-block':'none'}} type="primary" onClick={() => props.onCreate()}>{t('新建')}</Button>
              <Button style={{marginRight: '8px',display:'inline-block'}} type="primary" htmlType="submit">{t('搜索')}</Button>
              <Button className='reset-btn' onClick={() => onReset()}>{t('重置')}</Button>
              {/* <Button 
                style={{marginRight: '8px',display:props.isImport?'inline-block':'none'}}
                type="primary" onClick={() => {
                    props.onDownloadTemp()
                  }}>下载模板</Button> */}
          </div>
          <a style={{lineHeight:'30px'}} onClick={() => props.setExpand?props.setExpand(!expand):setExpand(!expand)}>
            {!expand ? <span><DownOutlined/> {t('展开')}</span> : <span><UpOutlined/> {t('收起')}</span>}
          </a>
        </div>
      </Form>
    </div>
  )
})
